module.exports = __webpack_public_path__ + "img/990RecActiveEN1.1d649c3f.png";